// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "controls-P0wsJ";
var _4 = "switchContainer-3VbUL";
var _5 = "business-1Phqv";
var _6 = "priorityBoarding-2yipJ";
var _7 = "switchContainer__active-1tgoi";
var _8 = "switchContainer__label-36ovM";
var _9 = "add-1mmoQ";
var _a = "bg_zia-2BqcI";
var _b = "bg_aer-2nasL";
export { _1 as "__esModule", _2 as "mobile", _3 as "controls", _4 as "switchContainer", _5 as "business", _6 as "priorityBoarding", _7 as "switchContainer__active", _8 as "switchContainer__label", _9 as "add", _a as "bg_zia", _b as "bg_aer" }
export default { "__esModule": _1, "mobile": _2, "controls": _3, "switchContainer": _4, "business": _5, "priorityBoarding": _6, "switchContainer__active": _7, "switchContainer__label": _8, "add": _9, "bg_zia": _a, "bg_aer": _b }
